import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import DataTable from "../../components/data-table/DataTable";
import {getReferralPrograms, navLinks} from "../../services/organization";
import LeftBar from "../../components/left-bar/LeftBar";
import NavigationLinks from "../../components/navigation-links/NavigationLinks";
import Content from "../../components/content/Content";
import SearchField from "../../components/fields/SearchField";
import ActionButton from "../../components/button/ActionButton";

const columnData = [
    { id: 'name', label: 'Название' },
    { id: 'percentsToMoney', label: 'Проценты в деньги' },
    { id: 'percentsToBarter', label: 'Проценты в бартер' },
    { id: 'calculatingTick', label: 'Расчетный период' },
];

const styles = theme => ({
});

export default
@withStyles(styles)
class ReferralProgramListPage extends React.Component {

    state = {
        search: {
            search: null
        },
        refreshTable: false
    };

    handleChange = prop => event => {
        this.setState({
            search: {
                ...this.state.search,
                [prop]: event.target.value,
            }
        });
    };

    handleClickSearch = () => {
        this.setState(state => ({ refreshTable: !state.refreshTable }));
    };

    handleAdd = () => {
        this.props.history.push(`/organization/referral-programs/view/0`);
    };

    getTableData = (...params) => {
        const {search} = this.state;
        return getReferralPrograms(search, ...params);
    };

    render() {
        // const { classes } = this.props;
        const { search, refreshTable } = this.state;

        return (
            <React.Fragment>
                <LeftBar navigationLinks={<NavigationLinks links={navLinks}/>}>
                    <SearchField
                        value={search.search}
                        onChange={this.handleChange('search')}
                        onClick={this.handleClickSearch}
                        label="Поиск"
                    />
                    <br />
                    <br />
                    <ActionButton onClick={this.handleAdd}>Добавить</ActionButton>
                </LeftBar>
                <Content title="Реферальные программы">
                    <DataTable
                        columnData={columnData}
                        dataFunc={this.getTableData}
                        linkTemplate={(item) => `/organization/referral-programs/view/${item.id}`}
                        selector={false}
                        refresh={refreshTable}
                    />
                </Content>
            </React.Fragment>
        );
    }
}